import IllustrationContainer from './IllustrationContainer';

export default IllustrationContainer;
